// extracted by mini-css-extract-plugin
module.exports = {"isDragging":"DragDropList__isDragging--1DI0M"};